import { customerEnvironment as env } from './environment.stage';

export const customerEnvironment = {
  ...env,
  customer: {
    alias: 'ketchum',
    name: 'Ketchum'
  },

  apis : {
    host: {
      host: 'https://ketch-flow.stage.ketchum.fspoon.org',
      apiKey: 'abd1e8af77ff5b94ae19ffa1088ab14bf57eb1a570d9875bd129f41a31bbf455',
      rootPath: 'api/v2',
      envPath: 'system/environment',
      headerApiKey: 'X-BooX-API-Key',
      headerSessionToken: 'X-BooX-Session-Token',
    },
    capacity: {
      host: 'https://ketch-flow.stage.ketchum.fspoon.org',
      apiKey: 'd245ab38d8e7d58f98817a8d2d68e550df0a109cb7631df557a2cd05d7483e47',
      rootPath: 'api/v2',
      headerApiKey: 'X-BooX-API-Key',
      headerSessionToken: 'X-BooX-Session-Token',
      envPath: 'system/environment',
    },
    skill: {
      host: 'https://ketch-flow.stage.ketchum.fspoon.org',
      apiKey: 'baab765dc7c63f721cff8dcf6c038372782c178e12df8c95765ddf462b04b5b1',
      rootPath: 'api/v2',
      headerApiKey: 'X-BooX-API-Key',
      headerSessionToken: 'X-BooX-Session-Token',
      envPath: 'system/environment',
    },
    veri: {
      host: 'https://ketch-flow.stage.ketchum.fspoon.org',
      apiKey: '055282ce69f73f914c7eb099b87ca7a3fa7335ac3b32496c54cf6116a56a2510',
      rootPath: 'api/v2',
      headerApiKey: 'X-BooX-API-Key',
      headerSessionToken: 'X-BooX-Session-Token',
      envPath: 'system/environment',
    },
    profile: {
      host: 'https://ketch-flow.stage.ketchum.fspoon.org',
      apiKey: '9fee6a067cbcf2870e6ece5bcd6db52c63c50ff9479bc976a623f9a13658f3ea',
      rootPath: 'api/v2',
      headerApiKey: 'X-BooX-API-Key',
      headerSessionToken: 'X-BooX-Session-Token',
      envPath: 'system/environment',
    },
    people: {
      host: 'https://ketch-flow.stage.ketchum.fspoon.org',
      apiKey: 'ac54730ec12ba33ed27d071c7970c4b9b06ed7713c7cac81b6fd2013c19ff0ae',
      rootPath: 'api/v2',
      headerApiKey: 'X-BooX-API-Key',
      headerSessionToken: 'X-BooX-Session-Token',
      envPath: 'system/environment',
    },
    impact: {
      host: 'https://ketch-flow.stage.ketchum.fspoon.org',
      apiKey: 'd25a3a72193716974de5ecba447584cb622ebcfcfda8e992391cc91e5fbd4396',
      rootPath: 'api/v2',
      headerApiKey: 'X-BooX-API-Key',
      headerSessionToken: 'X-BooX-Session-Token',
      envPath: 'system/environment',
    },
    admin: {
      host: 'https://ketch-flow.stage.ketchum.fspoon.org',
      apiKey: 'a7e7805cb112ba9e07e30aaa5a1b48be6138f8b952b55b8ba5ab976fc1f96b97',
      rootPath: 'api/v2',
      headerApiKey: 'X-BooX-API-Key',
      headerSessionToken: 'X-BooX-Session-Token',
      envPath: 'system/environment',
    },
  },
};
